module.exports = __webpack_public_path__ + "img/daichao1.859f205f.png";